/**
 * Inserts `text` into `value` replacing the range [start, end).
 * Selection indexes are clamped to the value length so out-of-range
 * carets (e.g. after the value changed) still behave safely.
 */
export function insertTextAtSelection(
  value: string,
  text: string,
  start: number,
  end: number,
): string {
  const clampedStart = Math.max(0, Math.min(start, value.length));
  const clampedEnd = Math.max(clampedStart, Math.min(end, value.length));
  return `${value.slice(0, clampedStart)}${text}${value.slice(clampedEnd)}`;
}
